import config, { Country } from 'config';
import moment from 'moment';

export default function formatDate(date: string | Date, applyTime = false) {
  const country = config.get('country');

  const format = {
    [Country.EE]: {
      date: 'DD.MM.YYYY',
      time: 'HH:mm',
    },
    [Country.ZA]: {
      date: 'DD/MM/YYYY',
      time: 'HH:mm',
    },
    [Country.KE]: {
      date: 'DD/MM/YYYY',
      time: 'HH:mm',
    },
    [Country.EG]: {
      date: 'DD/MM/YYYY',
      time: 'HH:mm',
    },
  }[country] || {
    date: 'DD.MM.YYYY',
    time: 'HH:mm',
  };

  return moment(date).format([format.date, applyTime ? format.time : undefined].filter((exists) => exists).join(' '));
}
